import React from "react";
import { Tab } from "semantic-ui-react";

import { Caption, ExplanationHeader, Explanation } from "./common";

const LeverLearnPane = () => {
  return <Tab.Pane attached={true}>
      <Caption>
        What are the goals that your city has for the future? What types of
        transportation investments are you interested in making? We break down
        these goals into five main categories: Electrification for Private and
        Public sectors, Non-Motorized Transit, Public Transit, and Shared
        Mobility.
      </Caption>

      <ExplanationHeader>
        {" "}
        Non-Motorized Transit and Mobility-Oriented Development
      </ExplanationHeader>

      <Explanation>
        How do we reduce passenger kilometers traveled, and to what degree?
        Solutions include sidewalk and intersection improvement, first-last
        mile connectivity, community behavior shifts, mixed-use developments,
        and city area constraints.
      </Explanation>

      <ExplanationHeader> Public Transit </ExplanationHeader>

      <Explanation>
        Promote bus and metro ridership through researching public transit
        accessibility and coverage.
      </Explanation>

      <ExplanationHeader> Shared Mobility </ExplanationHeader>

      <Explanation>
        Increase the number of shared vehicles and the number of commercial
        vehicle services (rentals, carshare, ride-hailing).
      </Explanation>
    </Tab.Pane>;
};

export default LeverLearnPane;



// WEBPACK FOOTER //
// ./src/pages/modelLevers/panes/learnMore.js